import { render, staticRenderFns } from "./Morecourses.vue?vue&type=template&id=3593e572&"
import script from "./Morecourses.vue?vue&type=script&lang=js&"
export * from "./Morecourses.vue?vue&type=script&lang=js&"
import style0 from "./Morecourses.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports